var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Observable from "zen-observable";
import { PaymentProvider } from "@irati/types";
import checkoutService from "../../services/checkout";
var Basket = /** @class */ (function () {
    function Basket() {
        this.observers = [];
        this._paymentProvider = PaymentProvider.AdyenClassic;
        this.isLoading = false;
    }
    Object.defineProperty(Basket.prototype, "items", {
        get: function () {
            return this._items || [];
        },
        set: function (items) {
            this._items = items;
            this.fetchBreakdown();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Basket.prototype, "breakdown", {
        get: function () {
            return this._breakdown || emptyBreakdown();
        },
        set: function (breakdown) {
            this._breakdown = breakdown;
            this.isLoading = false;
            this.updateObservers();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Basket.prototype, "paymentProvider", {
        get: function () {
            return this._paymentProvider;
        },
        set: function (paymentProvider) {
            this._paymentProvider = paymentProvider;
            this.fetchBreakdown();
        },
        enumerable: false,
        configurable: true
    });
    Basket.prototype.updateObservers = function () {
        var _this = this;
        this.observers.forEach(function (observer) {
            if (observer.next) {
                observer.next({ items: _this.items, breakdown: _this.breakdown, isLoading: _this.isLoading });
            }
        });
    };
    Basket.prototype.fetchBreakdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.items.length) return [3 /*break*/, 6];
                        this.updateObservers();
                        _a = this.paymentProvider;
                        switch (_a) {
                            case PaymentProvider.Zip: return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 3];
                    case 1:
                        _b = this;
                        return [4 /*yield*/, checkoutService.totalWithZipRate(this.items)];
                    case 2:
                        _b.breakdown = _d.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        _c = this;
                        return [4 /*yield*/, checkoutService.total(this.items)];
                    case 4:
                        _c.breakdown = _d.sent();
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        this.breakdown = emptyBreakdown();
                        _d.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    Basket.prototype.setProduct = function (entityType, entityId, productId, _a) {
        var count = _a.count, openValue = _a.openValue;
        var items = this.items;
        var item = items.find(function (t) { return t.entityId === entityId && t.productId === productId; });
        if (!item) {
            item = {
                entityType: entityType,
                entityId: entityId,
                productId: productId
            };
            items.push(item);
        }
        item.openValue = openValue;
        item.count = count;
        // trigger refresh
        if (!item.count && !item.openValue) {
            this.items = items.filter(function (t) { return t !== item; });
        }
        else {
            this.items = items;
        }
    };
    Basket.prototype.clear = function () {
        this.items = [];
    };
    Basket.prototype.subscribe = function (onNext, onError, onComplete) {
        var _this = this;
        return new Observable(function (observer) {
            observer.next({ items: _this.items, breakdown: _this.breakdown, isLoading: _this.isLoading });
            _this.observers.push(observer);
            return function () {
                _this.observers = _this.observers.filter(function (t) { return t !== observer; });
            };
        }).subscribe(onNext, onError, onComplete);
    };
    return Basket;
}());
var basket = new Basket();
export default basket;
function emptyBreakdown() {
    return { items: [], total: { discountPercentage: 0, originalPrice: 0, amount: 0, currency: "", vat: 0 } };
}
